<template>
    <div ref="container">
        <a-modal 
            :title="title" 
            width="95%" 
            :visible="visible" 
            :confirmLoading="confirmLoading" 
            :maskStyle="{'top':'93px','left':'154px'}" 
            :maskClosable="false" 
            @ok="handleOk" 
            @cancel="handleCancel"
            @closeModal="closeModal" 
            cancelText="关闭" 
            style="top:50px;height: 90%;"
        >
            <div>{{details}}</div>
        </a-modal>
    </div>
</template>
<script>
// import pick from 'lodash.pick'
import { getObjectDetaillist } from '@/api/api'
export default {
    name: 'eventTraceDetail',
    components: {
        GetTraceCode
    },
    data () {
        return {
            title: '追溯信息',
            visible: false, 
            detailVisible: false, 
            confirmLoading: false,
            selectedItem: {},
            details: {},
            model: {},
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
            },
            listData:[]
        }
    },
    methods: {
        show(e){
            this.visible = true
            console.log(e,'e===================')
            this.getTraceList(e.id)
        },
        // 获取追溯事件码列表
        async getTraceList(id){
            const params = { 
                traceProdProcessId: id,
                pageNo: 1,
                pageSize: 10
            }
            const res = await getEventListByProcessId(params)
            if( res.code == 200 && res.success == true ){
                this.listData = res.result.records
            }
            console.log(res,'事件码列表===================')
        },
        handleOk() {
          this.visible = false;
        },
        handleCancel(){
          this.visible = false;
        },
        closeModal(){
          this.visible = false;
        },
        viewDetails(item) {
            this.selectedItem = item;
            this.detailVisible = true;
            this.getEventTraceDetail(item.traceCode)
            console.log(item,'item===================')
        },
        async getEventTraceDetail(traceCode){
            const params = { 
                eventCode: traceCode,
                currentPage: 1,
                pageSize: 10
            }
            const res = await getObjectDetaillist(params)
            if( res.code == 200 && res.success == true ){
                this.details = res.result.data[0]
            }
            console.log(res,'物码列表===================')
        },
        handleDetailOk(){
            this.detailVisible = false;
        },
        handleDetailCancel(){
            this.detailVisible = false;
        },
    }
}
</script>
<style lang="less" scoped>

</style>